var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('theme-comp-switch',{attrs:{"defaultComp":_vm.defaultErrorPage,"lalamoveComp":_vm.lalamoveErrorPage}},[_c('div',[_vm._v(_vm._s(_vm.$t('act_risk_error')))]),_c('div',{staticClass:"errorTip"},[_vm._v(_vm._s(_vm.$t('act_risk_error_tip')))])])}
var staticRenderFns = []

export { render, staticRenderFns }